import { useState } from "react";
import { useAuth } from "../context/AuthContext";

const apiBase = import.meta.env.VITE_API_BASE;

export default function Profile() {
    const { user } = useAuth();
    const [fullName, setFullName] = useState(user?.fullName || "");
    const [phone, setPhone] = useState(user?.phone || "");
    const [msg, setMsg] = useState("");

    async function handleUpdate(e: React.FormEvent) {
        e.preventDefault();
        setMsg("");

        try {
            const token =
                localStorage.getItem("authToken") ||
                sessionStorage.getItem("authToken");

            const res = await fetch(`${apiBase}/api/user/profile`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ fullName, phone }),
            });

            if (!res.ok) {
                const err = await res.text();
                throw new Error(err || "Failed to update profile");
            }

            setMsg("✅ Profile updated successfully!");
        } catch (err: any) {
            setMsg(`❌ ${err.message}`);
        }
    }

    return (
        <div className="p-6 max-w-md mx-auto">
            <h1 className="text-xl font-bold mb-4">Update Profile</h1>
            <form onSubmit={handleUpdate} className="space-y-4">
                <div>
                    <label className="block text-sm">Full Name</label>
                    <input
                        type="text"
                        className="w-full border rounded px-3 py-2"
                        value={fullName}
                        onChange={(e) => setFullName(e.target.value)}
                    />
                </div>

                <div>
                    <label className="block text-sm">Phone</label>
                    <input
                        type="tel"
                        className="w-full border rounded px-3 py-2"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                    />
                </div>

                <button
                    type="submit"
                    className="rounded bg-indigo-600 px-4 py-2 text-white hover:bg-indigo-700"
                >
                    Save Changes
                </button>
            </form>
            {msg && <p className="mt-3 text-sm">{msg}</p>}
        </div>
    );
}
